import { useLazyQuery, useQuery } from '@apollo/client';
import { GET_DEALER_ACCOUNT, GET_PARTNER_LINK, GET_PARTNER_LINK_METRICS, GET_PARTNERS_PROPOSALS } from '../api';
import { ProposalsTableDataResponse, ProposalsTableDataVariables } from '../api/types';

export function useFetchDealerDetailsPage(currentAccountId: string, partnerLinkId: string) {
  const { loading: partnerLinkLoading } = useQuery(GET_PARTNER_LINK, {
    variables: {
      id: partnerLinkId,
    },
    async onCompleted(data) {
      const partnerLink = data?.partnerLink;
      await getDealerAccount({ variables: { dynamicsId: partnerLink.dynamicsPartnerAccountId } });
    },
  });

  const { data: partnerLinkMetricsData, loading: partnerLinkMetricsLoading } = useQuery(GET_PARTNER_LINK_METRICS, {
    variables: {
      partnerLinkId,
    },
  });

  const { data: proposalsData, loading: proposalsLoading } = useQuery<
    ProposalsTableDataResponse,
    ProposalsTableDataVariables
  >(GET_PARTNERS_PROPOSALS, {
    variables: { accountId: currentAccountId, partnerLinkId },
  });

  const [getDealerAccount, { data: dealerAccountData, loading: dealerAccountLoading, refetch: refetchDealerAccount }] =
    useLazyQuery(GET_DEALER_ACCOUNT);

  const isLoading = partnerLinkLoading || partnerLinkMetricsLoading || dealerAccountLoading || proposalsLoading;
  return {
    isLoading,
    partnerLinkMetrics: partnerLinkMetricsData?.partnerLinkMetrics,
    dealerAccount: dealerAccountData?.publicAccount,
    proposals: proposalsData?.partnersProposals,
    refetchDealerAccount,
  };
}
